import { render, staticRenderFns } from "./MyPostsPage.vue?vue&type=template&id=d58f4ade&scoped=true"
import script from "./MyPostsPage.vue?vue&type=script&lang=js"
export * from "./MyPostsPage.vue?vue&type=script&lang=js"
import style0 from "./MyPostsPage.vue?vue&type=style&index=0&id=d58f4ade&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58f4ade",
  null
  
)

export default component.exports